<template>
  <div class="incoming-tender-list-header incoming-tender-list-row">
    <div class="tender-list-cell first-row-full-height" />
    <div class="tender-list-cell first-row-full-height">
      {{ $t('Description of work') }}
    </div>
    <div class="tender-list-cell first-row-full-height">
      {{ $t('Unit') }}
    </div>
    <div class="tender-list-cell first-row-full-height right-border">
      {{ $t('Quantity') }}
    </div>
    <div
      v-for="i in GENERAL_ESTIMATE_COLUMN_WIDTH"
      :key="i"
      class="tender-list-cell"
      :class="{ 'right-border': i === GENERAL_ESTIMATE_COLUMN_WIDTH }"
    />
    <div v-for="(offer, index) in offers" :key="offer.id" class="d-contents">
      <div class="tender-list-cell">{{ $t('Per unit') }} ≈ {{ currencySymbols[currency] }}</div>
      <div v-if="openedColumns.includes(index)" class="d-contents">
        <div class="tender-list-cell">{{ $t('Labour') }} ≈ {{ currencySymbols[currency] }}</div>
        <div class="tender-list-cell">{{ $t('Materials') }} ≈ {{ currencySymbols[currency] }}</div>
        <div class="tender-list-cell">{{ $t('Tools') }} ≈ {{ currencySymbols[currency] }}</div>
      </div>
      <div class="tender-list-cell tender-list-cell__breakdown-header right-border spacex-8">
        <ExpandButton @click="$emit('toggle-column', index)" />
        <div>{{ $t('Total') }} ≈ {{ currencySymbols[currency] }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import ExpandButton from '@/components/tender/tender-list/ExpandButton';
  import { GENERAL_ESTIMATE_COLUMN_WIDTH } from '@/containers/tender/tender-list/constants';
  import { mapState } from 'vuex';

  export default {
    name: 'TenderBreakdownHeader',
    components: {
      ExpandButton,
    },
    props: {
      openedColumns: {
        type: Array,
        required: true,
      },
      offers: {
        type: Array,
        required: true,
      },
      currency: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        GENERAL_ESTIMATE_COLUMN_WIDTH,
      };
    },
    computed: {
      ...mapState('global', ['currencySymbols']),
    },
  };
</script>
